export function useDelay(timeout: number) {
  const isLoading = ref(true)
  setTimeout(() => {
    isLoading.value = false
  }, timeout)
  const loading = computed((): boolean => {
    return isLoading.value
  })
  return {
    loading
  }
}
